<template>
  <button class="ren-decoration-cp ren-decoration-cp-menu-item" type="button" :style="rowStyle">
    <i>{{ iconText }}</i>
    <span>
      <strong>{{ title }}</strong>
      <small v-if="subtitle">{{ subtitle }}</small>
    </span>
    <em v-if="badge">{{ badge }}</em>
    <b>›</b>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() =>
  stringValue(props.component.props?.title ?? props.component.props?.label, '菜单项')
)
const subtitle = computed(() => stringValue(props.component.props?.subtitle).trim())
const badge = computed(() => stringValue(props.component.props?.badge).trim())
const iconText = computed(() => {
  const value = stringValue(props.component.props?.icon).trim()
  if (!value) return title.value.slice(0, 1)
  return value.length <= 2 ? value : value.slice(0, 1)
})
const rowStyle = computed(() => {
  const style = props.component.style ?? {}
  const color = stringValue(style.textColor)
  const divider = stringValue(style.dividerColor)
  return {
    color: color || undefined,
    borderBottomColor: divider || undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 42px;
  margin: 0;
  padding: 8px 12px;
  border: 0;
  border-bottom: 1px solid var(--ren-theme-border);
  background: transparent;
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: default;
}

.ren-decoration-cp-menu-item i,
.ren-decoration-cp-menu-item b {
  flex: 0 0 auto;
  font-style: normal;
}

.ren-decoration-cp-menu-item span {
  min-width: 0;
  flex: 1;
  display: grid;
  gap: 4px;
}

.ren-decoration-cp-menu-item small,
.ren-decoration-cp-menu-item em {
  color: var(--ren-theme-muted);
  font-size: 12px;
  font-style: normal;
}

.ren-decoration-cp-menu-item strong,
.ren-decoration-cp-menu-item small {
  overflow-wrap: anywhere;
}
</style>
